// import React, { useState, useEffect } from 'react';
// import { API_URL } from "../../Constants";

// // --- Helpers ---

// // Handle Java LocalDateTime array [year, month, day, hour, minute, second, ns]
// const formatDate = (dateArr) => {
//   if (!Array.isArray(dateArr) || dateArr.length < 3) return '-';
//   const date = new Date(
//     dateArr[0], 
//     dateArr[1] - 1, 
//     dateArr[2], 
//     dateArr[3] || 0, 
//     dateArr[4] || 0
//   );
//   return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
// };

// // --- Icons (Inline SVGs) ---

// const Server = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
//     <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
//     <line x1="6" y1="6" x2="6.01" y2="6"></line>
//     <line x1="6" y1="18" x2="6.01" y2="18"></line>
//   </svg>
// );

// const Power = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
//     <line x1="12" y1="2" x2="12" y2="12"></line>
//   </svg>
// );

// const Plus = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <line x1="12" y1="5" x2="12" y2="19"></line>
//     <line x1="5" y1="12" x2="19" y2="12"></line>
//   </svg>
// );

// const RefreshCw = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="23 4 23 10 17 10"></polyline>
//     <polyline points="1 20 1 14 7 14"></polyline>
//     <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
//   </svg>
// );

// const Trash2 = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="3 6 5 6 21 6"></polyline>
//     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//     <line x1="10" y1="11" x2="10" y2="17"></line>
//     <line x1="14" y1="11" x2="14" y2="17"></line>
//   </svg>
// );

// const Edit3 = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M12 20h9"></path>
//     <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
//   </svg>
// );

// const Activity = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
//   </svg>
// );

// const ShieldAlert = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
//     <line x1="12" y1="8" x2="12" y2="12"></line>
//     <line x1="12" y1="16" x2="12.01" y2="16"></line>
//   </svg>
// );

// const X = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <line x1="18" y1="6" x2="6" y2="18"></line>
//     <line x1="6" y1="6" x2="18" y2="18"></line>
//   </svg>
// );

// const CheckCircle = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
//     <polyline points="22 4 12 14.01 9 11.01"></polyline>
//   </svg>
// );

// const AlertCircle = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <circle cx="12" cy="12" r="10"></circle>
//     <line x1="12" y1="8" x2="12" y2="12"></line>
//     <line x1="12" y1="16" x2="12.01" y2="16"></line>
//   </svg>
// );

// const Network = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="16" y="16" width="6" height="6" rx="1" ry="1"></rect>
//     <rect x="2" y="16" width="6" height="6" rx="1" ry="1"></rect>
//     <rect x="9" y="2" width="6" height="6" rx="1" ry="1"></rect>
//     <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path>
//     <line x1="12" y1="12" x2="12" y2="8"></line>
//   </svg>
// );

// // --- Sub-Components (Defined BEFORE usage) ---

// const StatCard = ({ icon, label, value, color }) => (
//   <div className={`p-6 rounded-xl border ${color} bg-white shadow-sm flex items-center space-x-4`}>
//     <div className="p-3 bg-white rounded-lg shadow-sm border border-slate-100">
//       {icon}
//     </div>
//     <div>
//       <p className="text-sm font-medium text-slate-500 uppercase tracking-wide">{label}</p>
//       <p className="text-2xl font-bold text-slate-800">{value}</p>
//     </div>
//   </div>
// );

// const NodeCard = ({ node, onEdit, onDelete, onToggle }) => {
//   return (
//     <div className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden flex flex-col">
//       {/* Header */}
//       <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-start bg-slate-50/50">
//         <div>
//           <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
//             {node.name}
//           </h3>
//           <div className="flex items-center gap-2 mt-1">
//             <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
//               node.active ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-600'
//             }`}>
//               <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${node.active ? 'bg-emerald-500' : 'bg-slate-400'}`}></span>
//               {node.active ? 'Active' : 'Inactive'}
//             </span>
//             <span className="text-xs text-slate-400">•</span>
//             <span className="text-xs font-mono text-slate-500">{node.host}:{node.port}</span>
//           </div>
//         </div>
//         <div className="flex space-x-1">
//           <button 
//             onClick={onEdit}
//             className="p-2 text-slate-400 hover:text-indigo-600 hover:bg-white rounded-lg transition-all"
//             title="Edit Configuration"
//           >
//             <Edit3 className="w-4 h-4" />
//           </button>
//           <button 
//             onClick={onDelete}
//             className="p-2 text-slate-400 hover:text-red-600 hover:bg-white rounded-lg transition-all"
//             title="Delete Connection"
//           >
//             <Trash2 className="w-4 h-4" />
//           </button>
//         </div>
//       </div>

//       {/* Body */}
//       <div className="p-6 flex-1">
//         <div className="grid grid-cols-2 gap-4 text-sm">
//           <div>
//             <p className="text-slate-400 text-xs uppercase mb-1">System ID</p>
//             <p className="font-mono font-medium text-slate-700 bg-slate-50 px-2 py-1 rounded inline-block">
//               {node.systemId}
//             </p>
//           </div>
//           <div>
//             <p className="text-slate-400 text-xs uppercase mb-1">Binds</p>
//             <p className="font-medium text-slate-700 flex items-center">
//               <Network className="w-3 h-3 mr-1 text-indigo-500" />
//               {node.bindCount} Sessions
//             </p>
//           </div>
//           <div className="col-span-2">
//              <p className="text-slate-400 text-xs uppercase mb-1">Routing</p>
//              <div className="flex flex-wrap gap-2">
//                {node.allowedCampaignTypes && node.allowedCampaignTypes.length > 0 ? (
//                  node.allowedCampaignTypes.map(t => (
//                    <span key={t} className="px-2 py-1 bg-indigo-50 text-indigo-700 rounded-md text-xs font-medium border border-indigo-100">
//                      {t}
//                    </span>
//                  ))
//                ) : (
//                  <span className="text-slate-400 italic text-xs">All Traffic Allowed</span>
//                )}
//              </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer / Action */}
//       <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center justify-between">
//         <p className="text-xs text-slate-400">
//           Last Updated: {formatDate(node.updatedAt)}
//         </p>
        
//         <button
//           onClick={onToggle}
//           className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all shadow-sm ${
//             node.active 
//               ? 'bg-white border border-red-200 text-red-600 hover:bg-red-50' 
//               : 'bg-emerald-600 text-white hover:bg-emerald-700 border border-transparent'
//           }`}
//         >
//           <Power className="w-4 h-4" />
//           <span>{node.active ? 'Stop Node' : 'Start Node'}</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// // --- Main Component ---

// export const Controlpanel = () => {
//   // --- State ---
//   const [nodes, setNodes] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [stats, setStats] = useState({ total: 0, active: 0, totalBinds: 0 });
  
//   // Modal States
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingNode, setEditingNode] = useState(null); // null = create mode
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [nodeToDelete, setNodeToDelete] = useState(null);

//   // Notifications
//   const [notification, setNotification] = useState(null); // { type: 'success'|'error', message: '' }

//   // Form State
//   const [formData, setFormData] = useState({
//     name: '',
//     host: '',
//     port: 2775,
//     systemId: '',
//     password: '',
//     bindCount: 1,
//     active: true,
//     allowedCampaignTypes: [] 
//   });

//   // --- API Helpers ---
//   const getAuthHeader = () => {
//     // Ideally fetch from your auth context or local storage
//     const token = localStorage.getItem('token'); 
//     return { 
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${token}` 
//     };
//   };

//   const showNotification = (type, message) => {
//     setNotification({ type, message });
//     setTimeout(() => setNotification(null), 3000);
//   };

//   // --- Actions ---

//   const fetchNodes = async () => {
//     setIsLoading(true);
//     try {
//       // UPDATED: Using API_URL
//       const response = await fetch(`${API_URL}/api/admin/connections`, {
//         headers: getAuthHeader()
//       });
//       if (!response.ok) throw new Error('Failed to fetch nodes');
      
//       const data = await response.json();
//       setNodes(data);
      
//       // Calculate Stats
//       const active = data.filter(n => n.active).length;
//       const binds = data.reduce((acc, curr) => acc + (curr.active ? curr.bindCount : 0), 0);
//       setStats({ total: data.length, active, totalBinds: binds });

//     } catch (error) {
//       console.error(error);
//       showNotification('error', 'Could not load nodes. Is the server running?');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleToggleActive = async (node) => {
//     // UPDATED: Using API_URL
//     const endpoint = node.active 
//       ? `${API_URL}/api/admin/connections/${node.id}/stop` 
//       : `${API_URL}/api/admin/connections/${node.id}/start`;
    
//     try {
//       const response = await fetch(endpoint, {
//         method: 'POST',
//         headers: getAuthHeader()
//       });
      
//       if (!response.ok) throw new Error('Failed to toggle node state');
      
//       showNotification('success', `Node ${node.active ? 'stopped' : 'started'} successfully`);
//       fetchNodes(); // Refresh UI
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   const handleDelete = async () => {
//     if (!nodeToDelete) return;
//     try {
//       // UPDATED: Using API_URL
//       const response = await fetch(`${API_URL}/api/admin/connections/${nodeToDelete.id}`, {
//         method: 'DELETE',
//         headers: getAuthHeader()
//       });

//       if (!response.ok) throw new Error('Failed to delete node');

//       showNotification('success', 'Node deleted successfully');
//       setNodeToDelete(null);
//       setIsDeleteModalOpen(false);
//       fetchNodes();
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     // UPDATED: Using API_URL
//     const url = editingNode 
//       ? `${API_URL}/api/admin/connections/${editingNode.id}` 
//       : `${API_URL}/api/admin/connections`;
    
//     const method = editingNode ? 'PUT' : 'POST';

//     try {
//       const response = await fetch(url, {
//         method,
//         headers: getAuthHeader(),
//         body: JSON.stringify(formData)
//       });

//       if (!response.ok) {
//         const err = await response.text();
//         throw new Error(err || 'Operation failed');
//       }

//       showNotification('success', `Node ${editingNode ? 'updated' : 'created'} successfully`);
//       closeModal();
//       fetchNodes();
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   // --- Modal Helpers ---

//   const openCreateModal = () => {
//     setEditingNode(null);
//     setFormData({
//       name: '', host: '', port: 2775, systemId: '', password: '', 
//       bindCount: 1, active: true, allowedCampaignTypes: ['TRANSACTIONAL']
//     });
//     setIsModalOpen(true);
//   };

//   const openEditModal = (node) => {
//     setEditingNode(node);
//     setFormData({
//       name: node.name,
//       host: node.host,
//       port: node.port,
//       systemId: node.systemId,
//       password: node.password,
//       bindCount: node.bindCount,
//       active: node.active,
//       allowedCampaignTypes: node.allowedCampaignTypes || []
//     });
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setEditingNode(null);
//   };

//   // --- Effects ---
//   useEffect(() => {
//     fetchNodes();
//   }, []);

//   // --- Renderers ---

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800 font-sans">
//       {/* HEADER */}
//       <div className="bg-white border-b border-slate-200 shadow-sm sticky top-0 z-10">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
//           <div className="flex items-center space-x-3">
//             <div className="bg-indigo-600 p-2 rounded-lg">
//               <Server className="w-6 h-6 text-white" />
//             </div>
//             <p className="text-xl font-bold text-slate-800">SMPP Node Controller</p>
//           </div>
//           <div className="flex items-center space-x-3">
//             <button 
//               onClick={fetchNodes}
//               className="p-2 text-slate-500 hover:text-indigo-600 hover:bg-slate-100 rounded-full transition-colors"
//               title="Refresh Data"
//             >
//               <RefreshCw className={`w-5 h-5 ${isLoading ? 'animate-spin' : ''}`} />
//             </button>
//             <button 
//               onClick={openCreateModal}
//               className="flex items-center space-x-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm"
//             >
//               <Plus className="w-4 h-4" />
//               <span>New Connection</span>
//             </button>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
//         {/* STATS OVERVIEW */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//           <StatCard 
//             icon={<Server className="w-6 h-6 text-indigo-600" />} 
//             label="Total Nodes" 
//             value={stats.total} 
//             color="bg-indigo-50 border-indigo-100"
//           />
//           <StatCard 
//             icon={<Activity className="w-6 h-6 text-emerald-600" />} 
//             label="Active Nodes" 
//             value={stats.active} 
//             color="bg-emerald-50 border-emerald-100"
//           />
//           <StatCard 
//             icon={<Network className="w-6 h-6 text-blue-600" />} 
//             label="Total Active Binds" 
//             value={stats.totalBinds} 
//             color="bg-blue-50 border-blue-100"
//           />
//         </div>

//         {/* NODE GRID */}
//         {nodes.length === 0 && !isLoading ? (
//           <div className="text-center py-20 bg-white rounded-xl border border-dashed border-slate-300">
//             <Server className="w-12 h-12 text-slate-300 mx-auto mb-4" />
//             <h3 className="text-lg font-medium text-slate-900">No Connections Found</h3>
//             <p className="text-slate-500 mt-1">Get started by creating a new SMPP connection node.</p>
//             <button 
//               onClick={openCreateModal}
//               className="mt-6 text-indigo-600 font-medium hover:text-indigo-700"
//             >
//               + Create Node
//             </button>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
//             {nodes.map(node => (
//               <NodeCard 
//                 key={node.id} 
//                 node={node} 
//                 onEdit={() => openEditModal(node)}
//                 onDelete={() => { setNodeToDelete(node); setIsDeleteModalOpen(true); }}
//                 onToggle={() => handleToggleActive(node)}
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       {/* --- MODALS --- */}

//       {/* CREATE / EDIT MODAL */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm">
//           <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[90vh]">
//             <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50">
//               <h3 className="text-lg font-bold text-slate-800">
//                 {editingNode ? 'Edit Connection Node' : 'New Connection Node'}
//               </h3>
//               <button onClick={closeModal} className="text-slate-400 hover:text-slate-600">
//                 <X className="w-5 h-5" />
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit} className="p-6 overflow-y-auto">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                
//                 <div className="col-span-2">
//                   <label className="block text-sm font-medium text-slate-700 mb-1">Connection Name</label>
//                   <input 
//                     type="text" 
//                     required
//                     placeholder="e.g. Jio-Transactional-Primary"
//                     className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
//                     value={formData.name}
//                     onChange={e => setFormData({...formData, name: e.target.value})}
//                   />
//                   <p className="text-xs text-slate-500 mt-1">A unique identifier for this node.</p>
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-1">Host IP</label>
//                   <input 
//                     type="text" 
//                     required
//                     placeholder="127.0.0.1"
//                     className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
//                     value={formData.host}
//                     onChange={e => setFormData({...formData, host: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-1">Port</label>
//                   <input 
//                     type="number" 
//                     required
//                     className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
//                     value={formData.port}
//                     onChange={e => setFormData({...formData, port: parseInt(e.target.value)})}
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-1">System ID</label>
//                   <input 
//                     type="text" 
//                     required
//                     className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
//                     value={formData.systemId}
//                     onChange={e => setFormData({...formData, systemId: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-1">Password</label>
//                   <input 
//                     type="text" 
//                     required
//                     className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none font-mono"
//                     value={formData.password}
//                     onChange={e => setFormData({...formData, password: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-slate-700 mb-1">Bind Count</label>
//                   <input 
//                     type="number" 
//                     min="1"
//                     max="50"
//                     required
//                     className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none"
//                     value={formData.bindCount}
//                     onChange={e => setFormData({...formData, bindCount: parseInt(e.target.value)})}
//                   />
//                   <p className="text-xs text-slate-500 mt-1">Parallel sessions to open.</p>
//                 </div>

//                 <div className="col-span-2">
//                   <label className="block text-sm font-medium text-slate-700 mb-2">Routing Traffic Types</label>
//                   <div className="flex gap-4">
//                     {['TRANSACTIONAL', 'PROMOTIONAL', 'OTP'].map(type => (
//                       <label key={type} className="flex items-center space-x-2 cursor-pointer border px-3 py-2 rounded-lg hover:bg-slate-50">
//                         <input 
//                           type="checkbox"
//                           checked={formData.allowedCampaignTypes.includes(type)}
//                           onChange={e => {
//                             const newTypes = e.target.checked 
//                               ? [...formData.allowedCampaignTypes, type]
//                               : formData.allowedCampaignTypes.filter(t => t !== type);
//                             setFormData({...formData, allowedCampaignTypes: newTypes});
//                           }}
//                           className="w-4 h-4 text-indigo-600 rounded focus:ring-indigo-500"
//                         />
//                         <span className="text-sm font-medium text-slate-700">{type}</span>
//                       </label>
//                     ))}
//                   </div>
//                 </div>

//               </div>

//               <div className="mt-8 flex justify-end space-x-3">
//                 <button 
//                   type="button"
//                   onClick={closeModal}
//                   className="px-4 py-2 text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 font-medium"
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   type="submit"
//                   className="px-6 py-2 text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 font-medium shadow-sm"
//                 >
//                   {editingNode ? 'Update Configuration' : 'Create Node'}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* DELETE CONFIRMATION MODAL */}
//       {isDeleteModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
//           <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6 animate-in zoom-in-95 duration-200">
//             <div className="flex items-center justify-center w-12 h-12 mx-auto bg-red-100 rounded-full mb-4">
//               <ShieldAlert className="w-6 h-6 text-red-600" />
//             </div>
//             <h3 className="text-xl font-bold text-center text-slate-900 mb-2">Delete Connection?</h3>
//             <p className="text-center text-slate-500 mb-6">
//               Are you sure you want to delete <strong>{nodeToDelete?.name}</strong>? This action will stop all active binds and remove the configuration permanently.
//             </p>
//             <div className="flex space-x-3">
//               <button 
//                 onClick={() => setIsDeleteModalOpen(false)}
//                 className="flex-1 px-4 py-2 text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 font-medium"
//               >
//                 Cancel
//               </button>
//               <button 
//                 onClick={handleDelete}
//                 className="flex-1 px-4 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 font-medium shadow-sm"
//               >
//                 Delete Forever
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* TOAST NOTIFICATION */}
//       {notification && (
//         <div className={`fixed bottom-6 right-6 px-6 py-4 rounded-lg shadow-xl flex items-center space-x-3 animate-in slide-in-from-bottom-5 z-50 ${
//           notification.type === 'success' ? 'bg-emerald-600 text-white' : 'bg-red-600 text-white'
//         }`}>
//           {notification.type === 'success' ? <CheckCircle className="w-5 h-5" /> : <AlertCircle className="w-5 h-5" />}
//           <span className="font-medium">{notification.message}</span>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Controlpanel;


// import React, { useState, useEffect } from 'react';
// import { API_URL } from "../../Constants";

// // --- Helpers ---

// // Handle Java LocalDateTime array [year, month, day, hour, minute, second, ns]
// const formatDate = (dateArr) => {
//   if (!Array.isArray(dateArr) || dateArr.length < 3) return '-';
//   const date = new Date(
//     dateArr[0], 
//     dateArr[1] - 1, 
//     dateArr[2], 
//     dateArr[3] || 0, 
//     dateArr[4] || 0
//   );
//   return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
// };

// // --- Icons (Inline SVGs - Styled via props) ---

// const Server = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
//     <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
//     <line x1="6" y1="6" x2="6.01" y2="6"></line>
//     <line x1="6" y1="18" x2="6.01" y2="18"></line>
//   </svg>
// );

// const Power = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
//     <line x1="12" y1="2" x2="12" y2="12"></line>
//   </svg>
// );

// const Plus = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <line x1="12" y1="5" x2="12" y2="19"></line>
//     <line x1="5" y1="12" x2="19" y2="12"></line>
//   </svg>
// );

// const RefreshCw = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="23 4 23 10 17 10"></polyline>
//     <polyline points="1 20 1 14 7 14"></polyline>
//     <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
//   </svg>
// );

// const Trash2 = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="3 6 5 6 21 6"></polyline>
//     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//     <line x1="10" y1="11" x2="10" y2="17"></line>
//     <line x1="14" y1="11" x2="14" y2="17"></line>
//   </svg>
// );

// const Edit3 = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M12 20h9"></path>
//     <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
//   </svg>
// );

// const Activity = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
//   </svg>
// );

// const ShieldAlert = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
//     <line x1="12" y1="8" x2="12" y2="12"></line>
//     <line x1="12" y1="16" x2="12.01" y2="16"></line>
//   </svg>
// );

// const X = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <line x1="18" y1="6" x2="6" y2="18"></line>
//     <line x1="6" y1="6" x2="18" y2="18"></line>
//   </svg>
// );

// const CheckCircle = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
//     <polyline points="22 4 12 14.01 9 11.01"></polyline>
//   </svg>
// );

// const AlertCircle = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <circle cx="12" cy="12" r="10"></circle>
//     <line x1="12" y1="8" x2="12" y2="12"></line>
//     <line x1="12" y1="16" x2="12.01" y2="16"></line>
//   </svg>
// );

// const Network = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="16" y="16" width="6" height="6" rx="1" ry="1"></rect>
//     <rect x="2" y="16" width="6" height="6" rx="1" ry="1"></rect>
//     <rect x="9" y="2" width="6" height="6" rx="1" ry="1"></rect>
//     <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path>
//     <line x1="12" y1="12" x2="12" y2="8"></line>
//   </svg>
// );

// // --- Sub-Components ---

// const StatCard = ({ icon, label, value }) => (
//   <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 flex items-center space-x-4 hover:border-[#0C4550]/30 transition-all duration-300">
//     <div className="p-4 bg-[#0C4550]/5 rounded-xl flex items-center justify-center">
//       {icon}
//     </div>
//     <div>
//       <p className="text-sm font-bold text-gray-500 uppercase tracking-wide">{label}</p>
//       <p className="text-2xl font-bold text-[#0C4550]">{value}</p>
//     </div>
//   </div>
// );

// const NodeCard = ({ node, onEdit, onDelete, onToggle }) => {
//   return (
//     <div className="bg-white rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col group">
//       {/* Header */}
//       <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#0C4550]/5 to-transparent flex justify-between items-start">
//         <div>
//           <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2 group-hover:text-[#0C4550] transition-colors">
//             {node.name}
//           </h3>
//           <div className="flex items-center gap-3 mt-2">
//             <span className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold tracking-wide ${
//               node.active ? 'bg-[#C5F637]/20 text-[#0C4550] border border-[#C5F637]/30' : 'bg-gray-100 text-gray-600 border border-gray-200'
//             }`}>
//               <span className={`w-2 h-2 rounded-full mr-2 ${node.active ? 'bg-[#0C4550]' : 'bg-gray-400'}`}></span>
//               {node.active ? 'Active' : 'Inactive'}
//             </span>
//             <span className="text-xs font-mono text-gray-500 bg-gray-50 px-2 py-0.5 rounded border border-gray-100">
//               {node.host}:{node.port}
//             </span>
//           </div>
//         </div>
//         <div className="flex space-x-1 opacity-80 hover:opacity-100">
//           <button 
//             onClick={onEdit}
//             className="p-2 text-gray-400 hover:text-[#0C4550] hover:bg-[#0C4550]/5 rounded-lg transition-all"
//             title="Edit Configuration"
//           >
//             <Edit3 className="w-4 h-4" />
//           </button>
//           <button 
//             onClick={onDelete}
//             className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all"
//             title="Delete Connection"
//           >
//             <Trash2 className="w-4 h-4" />
//           </button>
//         </div>
//       </div>

//       {/* Body */}
//       <div className="p-6 flex-1">
//         <div className="grid grid-cols-2 gap-6 text-sm">
//           <div>
//             <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">System ID</p>
//             <p className="font-mono font-medium text-[#0C4550] bg-[#0C4550]/5 px-3 py-1.5 rounded-lg inline-block border border-[#0C4550]/10">
//               {node.systemId}
//             </p>
//           </div>
//           <div>
//             <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Binds</p>
//             <p className="font-bold text-gray-700 flex items-center">
//               <Network className="w-4 h-4 mr-2 text-[#0C4550]" />
//               {node.bindCount} Sessions
//             </p>
//           </div>
//           <div className="col-span-2">
//              <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Allowed Traffic</p>
//              <div className="flex flex-wrap gap-2">
//                {node.allowedCampaignTypes && node.allowedCampaignTypes.length > 0 ? (
//                  node.allowedCampaignTypes.map(t => (
//                    <span key={t} className="px-2.5 py-1 bg-[#0C4550]/5 text-[#0C4550] rounded-md text-xs font-bold border border-[#0C4550]/10">
//                      {t}
//                    </span>
//                  ))
//                ) : (
//                  <span className="text-gray-400 italic text-xs">All Traffic Allowed</span>
//                )}
//              </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer / Action */}
//       <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
//         <p className="text-[10px] text-gray-400 font-medium uppercase tracking-wider">
//           Updated: {formatDate(node.updatedAt)}
//         </p>
        
//         <button
//           onClick={onToggle}
//           className={`flex items-center space-x-2 px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-sm ${
//             node.active 
//               ? 'bg-white border-2 border-red-100 text-red-500 hover:bg-red-50 hover:border-red-200' 
//               : 'bg-[#0C4550] text-white hover:bg-[#0A3A44] shadow-md hover:shadow-lg'
//           }`}
//         >
//           <Power className="w-4 h-4" />
//           <span>{node.active ? 'Stop Node' : 'Start Node'}</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// // --- Main Component ---

// export const Controlpanel = () => {
//   // --- State ---
//   const [nodes, setNodes] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [stats, setStats] = useState({ total: 0, active: 0, totalBinds: 0 });
  
//   // Modal States
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingNode, setEditingNode] = useState(null); // null = create mode
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [nodeToDelete, setNodeToDelete] = useState(null);

//   // Notifications
//   const [notification, setNotification] = useState(null); // { type: 'success'|'error', message: '' }

//   // Form State
//   const [formData, setFormData] = useState({
//     name: '',
//     host: '',
//     port: 2775,
//     systemId: '',
//     password: '',
//     bindCount: 1,
//     active: true,
//     allowedCampaignTypes: [] 
//   });

//   // Styles reused from Balance page
//   const inputClassName = "w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all duration-300 hover:border-[#0C4550]/30 shadow-sm";
//   const labelClassName = "block text-sm font-bold text-gray-700 mb-2";

//   // --- API Helpers ---
//   const getAuthHeader = () => {
//     const token = localStorage.getItem('token'); 
//     return { 
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${token}` 
//     };
//   };

//   const showNotification = (type, message) => {
//     setNotification({ type, message });
//     setTimeout(() => setNotification(null), 3000);
//   };

//   // --- Actions ---

//   const fetchNodes = async () => {
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${API_URL}/api/admin/connections`, {
//         headers: getAuthHeader()
//       });
//       if (!response.ok) throw new Error('Failed to fetch nodes');
      
//       const data = await response.json();
//       setNodes(data);
      
//       const active = data.filter(n => n.active).length;
//       const binds = data.reduce((acc, curr) => acc + (curr.active ? curr.bindCount : 0), 0);
//       setStats({ total: data.length, active, totalBinds: binds });

//     } catch (error) {
//       console.error(error);
//       showNotification('error', 'Could not load nodes. Is the server running?');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleToggleActive = async (node) => {
//     const endpoint = node.active 
//       ? `${API_URL}/api/admin/connections/${node.id}/stop` 
//       : `${API_URL}/api/admin/connections/${node.id}/start`;
    
//     try {
//       const response = await fetch(endpoint, {
//         method: 'POST',
//         headers: getAuthHeader()
//       });
      
//       if (!response.ok) throw new Error('Failed to toggle node state');
      
//       showNotification('success', `Node ${node.active ? 'stopped' : 'started'} successfully`);
//       fetchNodes(); 
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   const handleDelete = async () => {
//     if (!nodeToDelete) return;
//     try {
//       const response = await fetch(`${API_URL}/api/admin/connections/${nodeToDelete.id}`, {
//         method: 'DELETE',
//         headers: getAuthHeader()
//       });

//       if (!response.ok) throw new Error('Failed to delete node');

//       showNotification('success', 'Node deleted successfully');
//       setNodeToDelete(null);
//       setIsDeleteModalOpen(false);
//       fetchNodes();
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const url = editingNode 
//       ? `${API_URL}/api/admin/connections/${editingNode.id}` 
//       : `${API_URL}/api/admin/connections`;
    
//     const method = editingNode ? 'PUT' : 'POST';

//     try {
//       const response = await fetch(url, {
//         method,
//         headers: getAuthHeader(),
//         body: JSON.stringify(formData)
//       });

//       if (!response.ok) {
//         const err = await response.text();
//         throw new Error(err || 'Operation failed');
//       }

//       showNotification('success', `Node ${editingNode ? 'updated' : 'created'} successfully`);
//       closeModal();
//       fetchNodes();
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   // --- Modal Helpers ---

//   const openCreateModal = () => {
//     setEditingNode(null);
//     setFormData({
//       name: '', host: '', port: 2775, systemId: '', password: '', 
//       bindCount: 1, active: true, allowedCampaignTypes: ['TRANSACTIONAL']
//     });
//     setIsModalOpen(true);
//   };

//   const openEditModal = (node) => {
//     setEditingNode(node);
//     setFormData({
//       name: node.name,
//       host: node.host,
//       port: node.port,
//       systemId: node.systemId,
//       password: node.password,
//       bindCount: node.bindCount,
//       active: node.active,
//       allowedCampaignTypes: node.allowedCampaignTypes || []
//     });
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setEditingNode(null);
//   };

//   // --- Effects ---
//   useEffect(() => {
//     fetchNodes();
//   }, []);

//   // --- Renderers ---

//   return (
//     <div className="min-h-screen bg-[#F0EFEB] font-sans p-4 md:p-6 text-gray-800">
//       <div className="max-w-7xl mx-auto">
        
//         {/* --- HEADER SECTION --- */}
//         <div className="bg-[#0C4550] rounded-2xl shadow-xl mb-8 p-6 md:p-8 relative overflow-hidden">
//           {/* Decorative background element */}
//           <div className="absolute top-0 right-0 w-64 h-full bg-gradient-to-l from-[#C5F637]/10 to-transparent pointer-events-none" />
          
//           <div className="flex flex-col md:flex-row md:items-center justify-between relative z-10">
//             <div className="flex items-center gap-4 mb-6 md:mb-0">
//               <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center border border-white/10 shadow-lg">
//                 <Server className="h-8 w-8 text-[#C5F637]" />
//               </div>
//               <div>
//                 <h1 className="text-3xl font-bold text-white tracking-tight">SMPP Controller</h1>
//                 <p className="text-[#A7A08F] mt-1 font-medium">Manage connectivity nodes & binds</p>
//               </div>
//             </div>

//             <div className="flex items-center gap-3">
//                {/* Metrics / Actions in Header */}
//                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2 flex items-center gap-2 border border-white/10 shadow-lg">
//                 <button 
//                   onClick={fetchNodes}
//                   className="p-3 text-[#C5F637]/80 hover:text-[#C5F637] hover:bg-white/5 rounded-lg transition-all"
//                   title="Refresh Data"
//                 >
//                   <RefreshCw className={`w-6 h-6 ${isLoading ? 'animate-spin' : ''}`} />
//                 </button>
//                 <div className="h-8 w-px bg-white/10 mx-1"></div>
//                 <button 
//                   onClick={openCreateModal}
//                   className="flex items-center space-x-2 bg-[#C5F637] hover:bg-[#bcec2a] text-[#0C4550] px-5 py-3 rounded-lg text-sm font-bold transition-all shadow-md active:scale-95"
//                 >
//                   <Plus className="w-5 h-5" />
//                   <span>New Connection</span>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* --- STATS OVERVIEW --- */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//           <StatCard 
//             icon={<Server className="w-6 h-6 text-[#0C4550]" />} 
//             label="Total Nodes" 
//             value={stats.total} 
//           />
//           <StatCard 
//             icon={<Activity className="w-6 h-6 text-[#0C4550]" />} 
//             label="Active Nodes" 
//             value={stats.active} 
//           />
//           <StatCard 
//             icon={<Network className="w-6 h-6 text-[#0C4550]" />} 
//             label="Active Binds" 
//             value={stats.totalBinds} 
//           />
//         </div>

//         {/* --- NODE GRID --- */}
//         {nodes.length === 0 && !isLoading ? (
//           <div className="text-center py-24 bg-white rounded-2xl border-2 border-dashed border-gray-200">
//             <div className="w-16 h-16 bg-[#0C4550]/5 rounded-full flex items-center justify-center mx-auto mb-4">
//                <Server className="w-8 h-8 text-[#0C4550]/40" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-800">No Connections Found</h3>
//             <p className="text-gray-500 mt-2">Get started by creating a new SMPP connection node.</p>
//             <button 
//               onClick={openCreateModal}
//               className="mt-6 text-[#0C4550] font-bold hover:text-[#0A3A44] flex items-center justify-center gap-2 mx-auto"
//             >
//               <Plus className="w-4 h-4" /> Create Node
//             </button>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
//             {nodes.map(node => (
//               <NodeCard 
//                 key={node.id} 
//                 node={node} 
//                 onEdit={() => openEditModal(node)}
//                 onDelete={() => { setNodeToDelete(node); setIsDeleteModalOpen(true); }}
//                 onToggle={() => handleToggleActive(node)}
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       {/* --- MODALS --- */}

//       {/* CREATE / EDIT MODAL */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0C4550]/40 backdrop-blur-sm transition-all">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-200 border border-gray-100">
//             <div className="px-6 py-5 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
//               <h3 className="text-xl font-bold text-[#0C4550]">
//                 {editingNode ? 'Edit Connection Node' : 'New Connection Node'}
//               </h3>
//               <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition-colors p-1 hover:bg-gray-100 rounded-lg">
//                 <X className="w-6 h-6" />
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit} className="p-6 overflow-y-auto custom-scrollbar">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                
//                 <div className="col-span-2">
//                   <label className={labelClassName}>Connection Name</label>
//                   <input 
//                     type="text" 
//                     required
//                     placeholder="e.g. Jio-Transactional-Primary"
//                     className={inputClassName}
//                     value={formData.name}
//                     onChange={e => setFormData({...formData, name: e.target.value})}
//                   />
//                   <p className="text-xs text-gray-500 mt-1.5 font-medium ml-1">A unique identifier for this node.</p>
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Host IP</label>
//                   <input 
//                     type="text" 
//                     required
//                     placeholder="127.0.0.1"
//                     className={inputClassName}
//                     value={formData.host}
//                     onChange={e => setFormData({...formData, host: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Port</label>
//                   <input 
//                     type="number" 
//                     required
//                     className={inputClassName}
//                     value={formData.port}
//                     onChange={e => setFormData({...formData, port: parseInt(e.target.value)})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>System ID</label>
//                   <input 
//                     type="text" 
//                     required
//                     className={inputClassName}
//                     value={formData.systemId}
//                     onChange={e => setFormData({...formData, systemId: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Password</label>
//                   <input 
//                     type="text" 
//                     required
//                     className={`${inputClassName} font-mono`}
//                     value={formData.password}
//                     onChange={e => setFormData({...formData, password: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Bind Count</label>
//                   <input 
//                     type="number" 
//                     min="1"
//                     max="50"
//                     required
//                     className={inputClassName}
//                     value={formData.bindCount}
//                     onChange={e => setFormData({...formData, bindCount: parseInt(e.target.value)})}
//                   />
//                   <p className="text-xs text-gray-500 mt-1.5 font-medium ml-1">Parallel sessions to open.</p>
//                 </div>

//                 <div className="col-span-2">
//                   <label className={labelClassName}>Routing Traffic Types</label>
//                   <div className="flex flex-wrap gap-4 mt-2">
//                     {['TRANSACTIONAL', 'PROMOTIONAL', 'OTP'].map(type => (
//                       <label key={type} className={`flex items-center space-x-3 cursor-pointer border-2 px-4 py-3 rounded-xl transition-all ${
//                         formData.allowedCampaignTypes.includes(type) 
//                         ? 'border-[#0C4550] bg-[#0C4550]/5' 
//                         : 'border-gray-200 hover:border-[#0C4550]/30'
//                       }`}>
//                         <div className={`w-5 h-5 rounded border flex items-center justify-center ${
//                            formData.allowedCampaignTypes.includes(type)
//                            ? 'bg-[#0C4550] border-[#0C4550]'
//                            : 'border-gray-300 bg-white'
//                         }`}>
//                             {formData.allowedCampaignTypes.includes(type) && <CheckCircle className="w-3.5 h-3.5 text-white" />}
//                         </div>
//                          {/* Hidden input for logic, styled div above for visuals */}
//                         <input 
//                           type="checkbox"
//                           className="hidden"
//                           checked={formData.allowedCampaignTypes.includes(type)}
//                           onChange={e => {
//                             const newTypes = e.target.checked 
//                               ? [...formData.allowedCampaignTypes, type]
//                               : formData.allowedCampaignTypes.filter(t => t !== type);
//                             setFormData({...formData, allowedCampaignTypes: newTypes});
//                           }}
//                         />
//                         <span className={`text-sm font-bold ${formData.allowedCampaignTypes.includes(type) ? 'text-[#0C4550]' : 'text-gray-600'}`}>{type}</span>
//                       </label>
//                     ))}
//                   </div>
//                 </div>

//               </div>

//               <div className="mt-8 flex justify-end space-x-3 pt-6 border-t border-gray-100">
//                 <button 
//                   type="button"
//                   onClick={closeModal}
//                   className="px-6 py-3 text-gray-700 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 font-bold transition-all"
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   type="submit"
//                   className="px-8 py-3 text-white bg-gradient-to-r from-[#0C4550] to-[#0A3A44] rounded-xl hover:shadow-lg font-bold transition-all active:scale-95 flex items-center gap-2"
//                 >
//                   {editingNode ? <Edit3 className="w-4 h-4"/> : <Plus className="w-4 h-4"/>}
//                   <span>{editingNode ? 'Update Config' : 'Create Node'}</span>
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* DELETE CONFIRMATION MODAL */}
//       {isDeleteModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0C4550]/60 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 animate-in zoom-in-95 duration-200 border border-gray-100 text-center">
//             <div className="flex items-center justify-center w-16 h-16 mx-auto bg-red-50 rounded-full mb-6 border-2 border-red-100">
//               <ShieldAlert className="w-8 h-8 text-red-500" />
//             </div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-2">Delete Connection?</h3>
//             <p className="text-gray-500 mb-8 leading-relaxed">
//               Are you sure you want to delete <strong className="text-gray-800">{nodeToDelete?.name}</strong>? This will stop all active binds and remove the configuration permanently.
//             </p>
//             <div className="flex space-x-3">
//               <button 
//                 onClick={() => setIsDeleteModalOpen(false)}
//                 className="flex-1 px-4 py-3 text-gray-700 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 font-bold transition-all"
//               >
//                 Cancel
//               </button>
//               <button 
//                 onClick={handleDelete}
//                 className="flex-1 px-4 py-3 text-white bg-red-500 hover:bg-red-600 rounded-xl font-bold shadow-md hover:shadow-lg transition-all"
//               >
//                 Delete Forever
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* TOAST NOTIFICATION */}
//       {notification && (
//         <div className={`fixed bottom-6 right-6 px-6 py-4 rounded-xl shadow-2xl flex items-center space-x-3 animate-in slide-in-from-bottom-5 z-50 border ${
//           notification.type === 'success' 
//             ? 'bg-[#C5F637] text-[#0C4550] border-[#bcec2a]' 
//             : 'bg-red-50 text-red-600 border-red-100'
//         }`}>
//           <div className={`p-1 rounded-full ${notification.type === 'success' ? 'bg-[#0C4550]/10' : 'bg-red-100'}`}>
//             {notification.type === 'success' ? <CheckCircle className="w-5 h-5" /> : <AlertCircle className="w-5 h-5" />}
//           </div>
//           <span className="font-bold">{notification.message}</span>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Controlpanel;





// import React, { useState, useEffect } from 'react';
// import { API_URL } from "../../Constants";

// // --- Helpers ---

// // Handle Java LocalDateTime array [year, month, day, hour, minute, second, ns]
// const formatDate = (dateArr) => {
//   if (!Array.isArray(dateArr) || dateArr.length < 3) return '-';
//   const date = new Date(
//     dateArr[0], 
//     dateArr[1] - 1, 
//     dateArr[2], 
//     dateArr[3] || 0, 
//     dateArr[4] || 0
//   );
//   return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
// };

// // --- Icons (Inline SVGs) ---

// const Server = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
//     <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
//     <line x1="6" y1="6" x2="6.01" y2="6"></line>
//     <line x1="6" y1="18" x2="6.01" y2="18"></line>
//   </svg>
// );

// const Power = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
//     <line x1="12" y1="2" x2="12" y2="12"></line>
//   </svg>
// );

// const Plus = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <line x1="12" y1="5" x2="12" y2="19"></line>
//     <line x1="5" y1="12" x2="19" y2="12"></line>
//   </svg>
// );

// const RefreshCw = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="23 4 23 10 17 10"></polyline>
//     <polyline points="1 20 1 14 7 14"></polyline>
//     <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
//   </svg>
// );

// const Trash2 = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="3 6 5 6 21 6"></polyline>
//     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
//     <line x1="10" y1="11" x2="10" y2="17"></line>
//     <line x1="14" y1="11" x2="14" y2="17"></line>
//   </svg>
// );

// const Edit3 = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M12 20h9"></path>
//     <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
//   </svg>
// );

// const Activity = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
//   </svg>
// );

// const ShieldAlert = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
//     <line x1="12" y1="8" x2="12" y2="12"></line>
//     <line x1="12" y1="16" x2="12.01" y2="16"></line>
//   </svg>
// );

// const X = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <line x1="18" y1="6" x2="6" y2="18"></line>
//     <line x1="6" y1="6" x2="18" y2="18"></line>
//   </svg>
// );

// const CheckCircle = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
//     <polyline points="22 4 12 14.01 9 11.01"></polyline>
//   </svg>
// );

// const AlertCircle = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <circle cx="12" cy="12" r="10"></circle>
//     <line x1="12" y1="8" x2="12" y2="12"></line>
//     <line x1="12" y1="16" x2="12.01" y2="16"></line>
//   </svg>
// );

// const Network = (props) => (
//   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
//     <rect x="16" y="16" width="6" height="6" rx="1" ry="1"></rect>
//     <rect x="2" y="16" width="6" height="6" rx="1" ry="1"></rect>
//     <rect x="9" y="2" width="6" height="6" rx="1" ry="1"></rect>
//     <path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"></path>
//     <line x1="12" y1="12" x2="12" y2="8"></line>
//   </svg>
// );

// // --- Sub-Components ---

// const StatCard = ({ icon, label, value }) => (
//   <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 flex items-center space-x-4 hover:border-[#0C4550]/30 transition-all duration-300">
//     <div className="p-4 bg-[#0C4550]/5 rounded-xl flex items-center justify-center">
//       {icon}
//     </div>
//     <div>
//       <p className="text-sm font-bold text-gray-500 uppercase tracking-wide">{label}</p>
//       <p className="text-2xl font-bold text-[#0C4550]">{value}</p>
//     </div>
//   </div>
// );

// const NodeCard = ({ node, onEdit, onDelete, onToggle }) => {
//   return (
//     <div className="bg-white rounded-2xl border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col group">
//       <div className="px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#0C4550]/5 to-transparent flex justify-between items-start">
//         <div>
//           <h3 className="text-lg font-bold text-gray-800 flex items-center gap-2 group-hover:text-[#0C4550] transition-colors">
//             {node.name}
//           </h3>
//           <div className="flex items-center gap-3 mt-2">
//             <span className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-bold tracking-wide ${
//               node.active ? 'bg-[#C5F637]/20 text-[#0C4550] border border-[#C5F637]/30' : 'bg-gray-100 text-gray-600 border border-gray-200'
//             }`}>
//               <span className={`w-2 h-2 rounded-full mr-2 ${node.active ? 'bg-[#0C4550]' : 'bg-gray-400'}`}></span>
//               {node.active ? 'Active' : 'Inactive'}
//             </span>
//             <span className="text-xs font-mono text-gray-500 bg-gray-50 px-2 py-0.5 rounded border border-gray-100">
//               {node.host}:{node.port}
//             </span>
//           </div>
//         </div>
//         <div className="flex space-x-1 opacity-80 hover:opacity-100">
//           <button 
//             onClick={onEdit}
//             className="p-2 text-gray-400 hover:text-[#0C4550] hover:bg-[#0C4550]/5 rounded-lg transition-all"
//             title="Edit Configuration"
//           >
//             <Edit3 className="w-4 h-4" />
//           </button>
//           <button 
//             onClick={onDelete}
//             className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all"
//             title="Delete Connection"
//           >
//             <Trash2 className="w-4 h-4" />
//           </button>
//         </div>
//       </div>

//       <div className="p-6 flex-1">
//         <div className="grid grid-cols-2 gap-6 text-sm">
//           <div>
//             <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">System ID</p>
//             <p className="font-mono font-medium text-[#0C4550] bg-[#0C4550]/5 px-3 py-1.5 rounded-lg inline-block border border-[#0C4550]/10">
//               {node.systemId}
//             </p>
//           </div>
//           <div>
//             <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Binds</p>
//             <p className="font-bold text-gray-700 flex items-center">
//               <Network className="w-4 h-4 mr-2 text-[#0C4550]" />
//               {node.bindCount} Sessions
//             </p>
//           </div>
//           <div className="col-span-2">
//               <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Allowed Traffic</p>
//               <div className="flex flex-wrap gap-2">
//                 {node.allowedCampaignTypes && node.allowedCampaignTypes.length > 0 ? (
//                   node.allowedCampaignTypes.map(t => (
//                     <span key={t} className="px-2.5 py-1 bg-[#0C4550]/5 text-[#0C4550] rounded-md text-xs font-bold border border-[#0C4550]/10">
//                       {t}
//                     </span>
//                   ))
//                 ) : (
//                   <span className="text-gray-400 italic text-xs">All Traffic Allowed</span>
//                 )}
//               </div>
//           </div>
//         </div>
//       </div>

//       <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-between">
//         <p className="text-[10px] text-gray-400 font-medium uppercase tracking-wider">
//           Updated: {formatDate(node.updatedAt)}
//         </p>
        
//         <button
//           onClick={onToggle}
//           className={`flex items-center space-x-2 px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-sm ${
//             node.active 
//               ? 'bg-white border-2 border-red-100 text-red-500 hover:bg-red-50 hover:border-red-200' 
//               : 'bg-[#0C4550] text-white hover:bg-[#0A3A44] shadow-md hover:shadow-lg'
//           }`}
//         >
//           <Power className="w-4 h-4" />
//           <span>{node.active ? 'Stop Node' : 'Start Node'}</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// // --- Main Component ---

// export const Controlpanel = () => {
//   // --- State ---
//   const [nodes, setNodes] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [stats, setStats] = useState({ total: 0, active: 0, totalBinds: 0 });
  
//   // New Slider State (0 = Off, 100 = Full)
//   const [trafficValue, setTrafficValue] = useState(100);

//   // Modal States
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingNode, setEditingNode] = useState(null);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [nodeToDelete, setNodeToDelete] = useState(null);

//   // Notifications
//   const [notification, setNotification] = useState(null);

//   // Form State
//   const [formData, setFormData] = useState({
//     name: '', host: '', port: 2775, systemId: '', password: '', 
//     bindCount: 1, active: true, allowedCampaignTypes: [] 
//   });

//   const inputClassName = "w-full px-4 py-3 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all duration-300 hover:border-[#0C4550]/30 shadow-sm";
//   const labelClassName = "block text-sm font-bold text-gray-700 mb-2";

//   // --- API Helpers ---
//   const getAuthHeader = () => {
//     const token = localStorage.getItem('token'); 
//     return { 
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${token}` 
//     };
//   };

//   const showNotification = (type, message) => {
//     setNotification({ type, message });
//     setTimeout(() => setNotification(null), 3000);
//   };

//   // --- New Slider Logic ---
//   const handleTrafficChange = async (e) => {
//     const val = parseInt(e.target.value);
//     setTrafficValue(val);
//     try {
//       const response = await fetch(`${API_URL}/api/admin/traffic-control`, {
//         method: 'POST',
//         headers: getAuthHeader(),
//         body: JSON.stringify({ trafficLevel: val })
//       });
//       if (!response.ok) throw new Error('Failed to update traffic');
//       showNotification('success', `Traffic set to ${val}%`);
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   // --- Actions ---

//   const fetchNodes = async () => {
//     setIsLoading(true);
//     try {
//       const response = await fetch(`${API_URL}/api/admin/connections`, {
//         headers: getAuthHeader()
//       });
//       if (!response.ok) throw new Error('Failed to fetch nodes');
      
//       const data = await response.json();
//       setNodes(data);
      
//       const active = data.filter(n => n.active).length;
//       const binds = data.reduce((acc, curr) => acc + (curr.active ? curr.bindCount : 0), 0);
//       setStats({ total: data.length, active, totalBinds: binds });

//     } catch (error) {
//       console.error(error);
//       showNotification('error', 'Could not load nodes. Is the server running?');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleToggleActive = async (node) => {
//     const endpoint = node.active 
//       ? `${API_URL}/api/admin/connections/${node.id}/stop` 
//       : `${API_URL}/api/admin/connections/${node.id}/start`;
    
//     try {
//       const response = await fetch(endpoint, {
//         method: 'POST',
//         headers: getAuthHeader()
//       });
      
//       if (!response.ok) throw new Error('Failed to toggle node state');
      
//       showNotification('success', `Node ${node.active ? 'stopped' : 'started'} successfully`);
//       fetchNodes(); 
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   const handleDelete = async () => {
//     if (!nodeToDelete) return;
//     try {
//       const response = await fetch(`${API_URL}/api/admin/connections/${nodeToDelete.id}`, {
//         method: 'DELETE',
//         headers: getAuthHeader()
//       });

//       if (!response.ok) throw new Error('Failed to delete node');

//       showNotification('success', 'Node deleted successfully');
//       setNodeToDelete(null);
//       setIsDeleteModalOpen(false);
//       fetchNodes();
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const url = editingNode 
//       ? `${API_URL}/api/admin/connections/${editingNode.id}` 
//       : `${API_URL}/api/admin/connections`;
    
//     const method = editingNode ? 'PUT' : 'POST';

//     try {
//       const response = await fetch(url, {
//         method,
//         headers: getAuthHeader(),
//         body: JSON.stringify(formData)
//       });

//       if (!response.ok) {
//         const err = await response.text();
//         throw new Error(err || 'Operation failed');
//       }

//       showNotification('success', `Node ${editingNode ? 'updated' : 'created'} successfully`);
//       closeModal();
//       fetchNodes();
//     } catch (error) {
//       showNotification('error', error.message);
//     }
//   };

//   // --- Modal Helpers ---

//   const openCreateModal = () => {
//     setEditingNode(null);
//     setFormData({
//       name: '', host: '', port: 2775, systemId: '', password: '', 
//       bindCount: 1, active: true, allowedCampaignTypes: ['TRANSACTIONAL']
//     });
//     setIsModalOpen(true);
//   };

//   const openEditModal = (node) => {
//     setEditingNode(node);
//     setFormData({
//       name: node.name,
//       host: node.host,
//       port: node.port,
//       systemId: node.systemId,
//       password: node.password,
//       bindCount: node.bindCount,
//       active: node.active,
//       allowedCampaignTypes: node.allowedCampaignTypes || []
//     });
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setEditingNode(null);
//   };

//   // --- Effects ---
//   useEffect(() => {
//     fetchNodes();
//   }, []);

//   return (
//     <div className="min-h-screen bg-[#F0EFEB] font-sans p-4 md:p-6 text-gray-800">
//       <div className="max-w-7xl mx-auto">
        
//         {/* --- HEADER SECTION --- */}
//         <div className="bg-[#0C4550] rounded-2xl shadow-xl mb-8 p-6 md:p-8 relative overflow-hidden">
//           <div className="absolute top-0 right-0 w-64 h-full bg-gradient-to-l from-[#C5F637]/10 to-transparent pointer-events-none" />
          
//           <div className="flex flex-col md:flex-row md:items-center justify-between relative z-10">
//             <div className="flex items-center gap-4 mb-6 md:mb-0">
//               <div className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center border border-white/10 shadow-lg">
//                 <Server className="h-8 w-8 text-[#C5F637]" />
//               </div>
//               <div>
//                 <h1 className="text-3xl font-bold text-white tracking-tight">SMPP Controller</h1>
//                 <p className="text-[#A7A08F] mt-1 font-medium">Manage connectivity nodes & binds</p>
//               </div>
//             </div>

//             <div className="flex items-center gap-3">
//                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-2 flex items-center gap-4 border border-white/10 shadow-lg">
                
//                 {/* --- MASTER TRAFFIC SLIDER --- */}
//                 <div className="flex flex-col items-center px-4">
//                   <div className="flex justify-between w-28 mb-1">
//                     <span className="text-[10px] font-black text-white/40 uppercase tracking-tighter">OFF</span>
//                     <span className="text-[10px] font-black text-[#C5F637] uppercase tracking-tighter">TRAFFIC</span>
//                   </div>
//                   <input 
//                     type="range" 
//                     min="0" 
//                     max="100" 
//                     step="100"
//                     value={trafficValue}
//                     onChange={handleTrafficChange}
//                     className="w-28 h-1.5 bg-white/20 rounded-lg appearance-none cursor-pointer accent-[#C5F637] transition-all hover:bg-white/30"
//                   />
//                 </div>

//                 <div className="h-8 w-px bg-white/10"></div>

//                 <button 
//                   onClick={fetchNodes}
//                   className="p-3 text-[#C5F637]/80 hover:text-[#C5F637] hover:bg-white/5 rounded-lg transition-all"
//                   title="Refresh Data"
//                 >
//                   <RefreshCw className={`w-6 h-6 ${isLoading ? 'animate-spin' : ''}`} />
//                 </button>
//                 <div className="h-8 w-px bg-white/10 mx-1"></div>
//                 <button 
//                   onClick={openCreateModal}
//                   className="flex items-center space-x-2 bg-[#C5F637] hover:bg-[#bcec2a] text-[#0C4550] px-5 py-3 rounded-lg text-sm font-bold transition-all shadow-md active:scale-95"
//                 >
//                   <Plus className="w-5 h-5" />
//                   <span>New Connection</span>
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* --- STATS OVERVIEW --- */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
//           <StatCard 
//             icon={<Server className="w-6 h-6 text-[#0C4550]" />} 
//             label="Total Nodes" 
//             value={stats.total} 
//           />
//           <StatCard 
//             icon={<Activity className="w-6 h-6 text-[#0C4550]" />} 
//             label="Active Nodes" 
//             value={stats.active} 
//           />
//           <StatCard 
//             icon={<Network className="w-6 h-6 text-[#0C4550]" />} 
//             label="Active Binds" 
//             value={stats.totalBinds} 
//           />
//         </div>

//         {/* --- NODE GRID --- */}
//         {nodes.length === 0 && !isLoading ? (
//           <div className="text-center py-24 bg-white rounded-2xl border-2 border-dashed border-gray-200">
//             <div className="w-16 h-16 bg-[#0C4550]/5 rounded-full flex items-center justify-center mx-auto mb-4">
//                <Server className="w-8 h-8 text-[#0C4550]/40" />
//             </div>
//             <h3 className="text-xl font-bold text-gray-800">No Connections Found</h3>
//             <p className="text-gray-500 mt-2">Get started by creating a new SMPP connection node.</p>
//             <button 
//               onClick={openCreateModal}
//               className="mt-6 text-[#0C4550] font-bold hover:text-[#0A3A44] flex items-center justify-center gap-2 mx-auto"
//             >
//               <Plus className="w-4 h-4" /> Create Node
//             </button>
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
//             {nodes.map(node => (
//               <NodeCard 
//                 key={node.id} 
//                 node={node} 
//                 onEdit={() => openEditModal(node)}
//                 onDelete={() => { setNodeToDelete(node); setIsDeleteModalOpen(true); }}
//                 onToggle={() => handleToggleActive(node)}
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       {/* --- MODALS --- */}

//       {/* CREATE / EDIT MODAL */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0C4550]/40 backdrop-blur-sm transition-all">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-200 border border-gray-100">
//             <div className="px-6 py-5 border-b border-gray-100 flex justify-between items-center bg-gray-50/50">
//               <h3 className="text-xl font-bold text-[#0C4550]">
//                 {editingNode ? 'Edit Connection Node' : 'New Connection Node'}
//               </h3>
//               <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition-colors p-1 hover:bg-gray-100 rounded-lg">
//                 <X className="w-6 h-6" />
//               </button>
//             </div>
            
//             <form onSubmit={handleSubmit} className="p-6 overflow-y-auto custom-scrollbar">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                
//                 <div className="col-span-2">
//                   <label className={labelClassName}>Connection Name</label>
//                   <input 
//                     type="text" 
//                     required
//                     placeholder="e.g. Jio-Transactional-Primary"
//                     className={inputClassName}
//                     value={formData.name}
//                     onChange={e => setFormData({...formData, name: e.target.value})}
//                   />
//                   <p className="text-xs text-gray-500 mt-1.5 font-medium ml-1">A unique identifier for this node.</p>
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Host IP</label>
//                   <input 
//                     type="text" 
//                     required
//                     placeholder="127.0.0.1"
//                     className={inputClassName}
//                     value={formData.host}
//                     onChange={e => setFormData({...formData, host: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Port</label>
//                   <input 
//                     type="number" 
//                     required
//                     className={inputClassName}
//                     value={formData.port}
//                     onChange={e => setFormData({...formData, port: parseInt(e.target.value)})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>System ID</label>
//                   <input 
//                     type="text" 
//                     required
//                     className={inputClassName}
//                     value={formData.systemId}
//                     onChange={e => setFormData({...formData, systemId: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Password</label>
//                   <input 
//                     type="text" 
//                     required
//                     className={`${inputClassName} font-mono`}
//                     value={formData.password}
//                     onChange={e => setFormData({...formData, password: e.target.value})}
//                   />
//                 </div>

//                 <div>
//                   <label className={labelClassName}>Bind Count</label>
//                   <input 
//                     type="number" 
//                     min="1"
//                     max="50"
//                     required
//                     className={inputClassName}
//                     value={formData.bindCount}
//                     onChange={e => setFormData({...formData, bindCount: parseInt(e.target.value)})}
//                   />
//                   <p className="text-xs text-gray-500 mt-1.5 font-medium ml-1">Parallel sessions to open.</p>
//                 </div>

//                 <div className="col-span-2">
//                   <label className={labelClassName}>Routing Traffic Types</label>
//                   <div className="flex flex-wrap gap-4 mt-2">
//                     {['TRANSACTIONAL', 'PROMOTIONAL', 'OTP'].map(type => (
//                       <label key={type} className={`flex items-center space-x-3 cursor-pointer border-2 px-4 py-3 rounded-xl transition-all ${
//                         formData.allowedCampaignTypes.includes(type) 
//                         ? 'border-[#0C4550] bg-[#0C4550]/5' 
//                         : 'border-gray-200 hover:border-[#0C4550]/30'
//                       }`}>
//                         <div className={`w-5 h-5 rounded border flex items-center justify-center ${
//                            formData.allowedCampaignTypes.includes(type)
//                            ? 'bg-[#0C4550] border-[#0C4550]'
//                            : 'border-gray-300 bg-white'
//                         }`}>
//                             {formData.allowedCampaignTypes.includes(type) && <CheckCircle className="w-3.5 h-3.5 text-white" />}
//                         </div>
//                         <input 
//                           type="checkbox"
//                           className="hidden"
//                           checked={formData.allowedCampaignTypes.includes(type)}
//                           onChange={e => {
//                             const newTypes = e.target.checked 
//                               ? [...formData.allowedCampaignTypes, type]
//                               : formData.allowedCampaignTypes.filter(t => t !== type);
//                             setFormData({...formData, allowedCampaignTypes: newTypes});
//                           }}
//                         />
//                         <span className={`text-sm font-bold ${formData.allowedCampaignTypes.includes(type) ? 'text-[#0C4550]' : 'text-gray-600'}`}>{type}</span>
//                       </label>
//                     ))}
//                   </div>
//                 </div>

//               </div>

//               <div className="mt-8 flex justify-end space-x-3 pt-6 border-t border-gray-100">
//                 <button 
//                   type="button"
//                   onClick={closeModal}
//                   className="px-6 py-3 text-gray-700 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 hover:border-gray-300 font-bold transition-all"
//                 >
//                   Cancel
//                 </button>
//                 <button 
//                   type="submit"
//                   className="px-8 py-3 text-white bg-gradient-to-r from-[#0C4550] to-[#0A3A44] rounded-xl hover:shadow-lg font-bold transition-all active:scale-95 flex items-center gap-2"
//                 >
//                   {editingNode ? <Edit3 className="w-4 h-4"/> : <Plus className="w-4 h-4"/>}
//                   <span>{editingNode ? 'Update Config' : 'Create Node'}</span>
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* DELETE CONFIRMATION MODAL */}
//       {isDeleteModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0C4550]/60 backdrop-blur-sm">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 animate-in zoom-in-95 duration-200 border border-gray-100 text-center">
//             <div className="flex items-center justify-center w-16 h-16 mx-auto bg-red-50 rounded-full mb-6 border-2 border-red-100">
//               <ShieldAlert className="w-8 h-8 text-red-500" />
//             </div>
//             <h3 className="text-2xl font-bold text-gray-800 mb-2">Delete Connection?</h3>
//             <p className="text-gray-500 mb-8 leading-relaxed">
//               Are you sure you want to delete <strong className="text-gray-800">{nodeToDelete?.name}</strong>? This will stop all active binds and remove the configuration permanently.
//             </p>
//             <div className="flex space-x-3">
//               <button 
//                 onClick={() => setIsDeleteModalOpen(false)}
//                 className="flex-1 px-4 py-3 text-gray-700 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 font-bold transition-all"
//               >
//                 Cancel
//               </button>
//               <button 
//                 onClick={handleDelete}
//                 className="flex-1 px-4 py-3 text-white bg-red-500 hover:bg-red-600 rounded-xl font-bold shadow-md hover:shadow-lg transition-all"
//               >
//                 Delete Forever
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* TOAST NOTIFICATION */}
//       {notification && (
//         <div className={`fixed bottom-6 right-6 px-6 py-4 rounded-xl shadow-2xl flex items-center space-x-3 animate-in slide-in-from-bottom-5 z-50 border ${
//           notification.type === 'success' 
//             ? 'bg-[#C5F637] text-[#0C4550] border-[#bcec2a]' 
//             : 'bg-red-50 text-red-600 border-red-100'
//         }`}>
//           <div className={`p-1 rounded-full ${notification.type === 'success' ? 'bg-[#0C4550]/10' : 'bg-red-100'}`}>
//             {notification.type === 'success' ? <CheckCircle className="w-5 h-5" /> : <AlertCircle className="w-5 h-5" />}
//           </div>
//           <span className="font-bold">{notification.message}</span>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Controlpanel;






import React, { useState, useEffect, useCallback } from 'react';
import { API_URL } from "../../Constants";

// ─── Icons ────────────────────────────────────────────────────────────────────

const Icon = ({ d, size = 24, ...p }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    {Array.isArray(d) ? d.map((el, i) => React.createElement(el.tag, { key: i, ...el.props })) : <path d={d} />}
  </svg>
);

const Server   = (p) => <Icon {...p} d={[{tag:'rect',props:{x:2,y:2,width:20,height:8,rx:2}},{tag:'rect',props:{x:2,y:14,width:20,height:8,rx:2}},{tag:'line',props:{x1:6,y1:6,x2:6.01,y2:6}},{tag:'line',props:{x1:6,y1:18,x2:6.01,y2:18}}]} />;
const Plus     = (p) => <Icon {...p} d={[{tag:'line',props:{x1:12,y1:5,x2:12,y2:19}},{tag:'line',props:{x1:5,y1:12,x2:19,y2:12}}]} />;
const RefreshCw= (p) => <Icon {...p} d={[{tag:'polyline',props:{points:'23 4 23 10 17 10'}},{tag:'polyline',props:{points:'1 20 1 14 7 14'}},{tag:'path',props:{d:'M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15'}}]} />;
const Trash2   = (p) => <Icon {...p} d={[{tag:'polyline',props:{points:'3 6 5 6 21 6'}},{tag:'path',props:{d:'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2'}},{tag:'line',props:{x1:10,y1:11,x2:10,y2:17}},{tag:'line',props:{x1:14,y1:11,x2:14,y2:17}}]} />;
const Edit3    = (p) => <Icon {...p} d={[{tag:'path',props:{d:'M12 20h9'}},{tag:'path',props:{d:'M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z'}}]} />;
const Activity = (p) => <Icon {...p} d={[{tag:'polyline',props:{points:'22 12 18 12 15 21 9 3 6 12 2 12'}}]} />;
const ShieldAlert=(p)=> <Icon {...p} d={[{tag:'path',props:{d:'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z'}},{tag:'line',props:{x1:12,y1:8,x2:12,y2:12}},{tag:'line',props:{x1:12,y1:16,x2:12.01,y2:16}}]} />;
const X        = (p) => <Icon {...p} d={[{tag:'line',props:{x1:18,y1:6,x2:6,y2:18}},{tag:'line',props:{x1:6,y1:6,x2:18,y2:18}}]} />;
const CheckCircle=(p)=> <Icon {...p} d={[{tag:'path',props:{d:'M22 11.08V12a10 10 0 1 1-5.93-9.14'}},{tag:'polyline',props:{points:'22 4 12 14.01 9 11.01'}}]} />;
const AlertCircle=(p)=> <Icon {...p} d={[{tag:'circle',props:{cx:12,cy:12,r:10}},{tag:'line',props:{x1:12,y1:8,x2:12,y2:12}},{tag:'line',props:{x1:12,y1:16,x2:12.01,y2:16}}]} />;
const Network  = (p) => <Icon {...p} d={[{tag:'rect',props:{x:16,y:16,width:6,height:6,rx:1}},{tag:'rect',props:{x:2,y:16,width:6,height:6,rx:1}},{tag:'rect',props:{x:9,y:2,width:6,height:6,rx:1}},{tag:'path',props:{d:'M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3'}},{tag:'line',props:{x1:12,y1:12,x2:12,y2:8}}]} />;
const Zap      = (p) => <Icon {...p} d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />;
const Wifi     = (p) => <Icon {...p} d={[{tag:'path',props:{d:'M5 12.55a11 11 0 0 1 14.08 0'}},{tag:'path',props:{d:'M1.42 9a16 16 0 0 1 21.16 0'}},{tag:'path',props:{d:'M8.53 16.11a6 6 0 0 1 6.95 0'}},{tag:'line',props:{x1:12,y1:20,x2:12.01,y2:20}}]} />;
const WifiOff  = (p) => <Icon {...p} d={[{tag:'line',props:{x1:1,y1:1,x2:23,y2:23}},{tag:'path',props:{d:'M16.72 11.06A10.94 10.94 0 0 1 19 12.55'}},{tag:'path',props:{d:'M5 12.55a10.94 10.94 0 0 1 5.17-2.39'}},{tag:'path',props:{d:'M10.71 5.05A16 16 0 0 1 22.56 9'}},{tag:'path',props:{d:'M1.42 9a15.91 15.91 0 0 1 4.7-2.88'}},{tag:'path',props:{d:'M8.53 16.11a6 6 0 0 1 6.95 0'}},{tag:'line',props:{x1:12,y1:20,x2:12.01,y2:20}}]} />;
const Loader   = (p) => <Icon {...p} d={[{tag:'line',props:{x1:12,y1:2,x2:12,y2:6}},{tag:'line',props:{x1:12,y1:18,x2:12,y2:22}},{tag:'line',props:{x1:4.93,y1:4.93,x2:7.76,y2:7.76}},{tag:'line',props:{x1:16.24,y1:16.24,x2:19.07,y2:19.07}},{tag:'line',props:{x1:2,y1:12,x2:6,y2:12}},{tag:'line',props:{x1:18,y1:12,x2:22,y2:12}},{tag:'line',props:{x1:4.93,y1:19.07,x2:7.76,y2:16.24}},{tag:'line',props:{x1:16.24,y1:7.76,x2:19.07,y2:4.93}}]} />;

// ─── Status helpers ────────────────────────────────────────────────────────────

const STATUS_CONFIG = {
  CONNECTED:    { dot: 'bg-emerald-400 shadow-emerald-400/60 shadow-sm',  badge: 'bg-emerald-50 text-emerald-700 border-emerald-200',   pulse: true  },
  RECONNECTING: { dot: 'bg-amber-400 shadow-amber-400/60 shadow-sm',     badge: 'bg-amber-50 text-amber-700 border-amber-200',         pulse: true  },
  DISCONNECTED: { dot: 'bg-red-400',                                       badge: 'bg-red-50 text-red-700 border-red-200',               pulse: false },
};

const getStatus = (bind) => {
  if (bind.bound)        return 'CONNECTED';
  if (bind.reconnecting) return 'RECONNECTING';
  return 'DISCONNECTED';
};

// ─── Sub-components ────────────────────────────────────────────────────────────

const StatCard = ({ icon, label, value, accent }) => (
  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex items-center gap-4 hover:border-[#0C4550]/20 transition-all duration-200">
    <div className={`p-3 rounded-xl ${accent || 'bg-[#0C4550]/5'} flex-shrink-0`}>{icon}</div>
    <div>
      <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">{label}</p>
      <p className="text-2xl font-black text-[#0C4550] leading-tight">{value}</p>
    </div>
  </div>
);

const WindowBar = ({ pending, max }) => {
  const pct = max > 0 ? Math.min(100, Math.round((pending / max) * 100)) : 0;
  const color = pct > 85 ? 'bg-red-400' : pct > 60 ? 'bg-amber-400' : 'bg-emerald-400';
  return (
    <div>
      <div className="flex justify-between mb-1">
        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Window</span>
        <span className="text-[10px] font-bold text-gray-500">{pending}/{max}</span>
      </div>
      <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
        <div className={`h-full rounded-full transition-all duration-700 ${color}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

const BindCard = ({ bind, onEdit, onDelete }) => {
  const status = getStatus(bind);
  const cfg = STATUS_CONFIG[status];

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden flex flex-col group">

      {/* Header */}
      <div className="px-5 py-4 border-b border-gray-50 flex justify-between items-start">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold border ${cfg.badge}`}>
              <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot} ${cfg.pulse ? 'animate-pulse' : ''}`} />
              {status}
            </span>
            {bind.atCapacity && (
              <span className="px-2 py-0.5 bg-red-50 text-red-600 text-[10px] font-black uppercase tracking-wider rounded-md border border-red-100">
                AT CAPACITY
              </span>
            )}
          </div>
          <p className="font-mono text-xs text-gray-400 truncate">{bind.host}:{bind.port}</p>
        </div>
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0 ml-2">
          <button onClick={onEdit} className="p-1.5 text-gray-400 hover:text-[#0C4550] hover:bg-[#0C4550]/5 rounded-lg transition-all" title="Edit">
            <Edit3 className="w-4 h-4" />
          </button>
          <button onClick={onDelete} className="p-1.5 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all" title="Delete">
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* Body */}
      <div className="p-5 flex-1 space-y-4">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Bind ID</p>
            <p className="font-mono font-semibold text-[#0C4550] text-xs bg-[#0C4550]/5 px-2 py-1 rounded-lg truncate border border-[#0C4550]/10">
              {bind.id}
            </p>
          </div>
          <div>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">System ID</p>
            <p className="font-mono font-semibold text-gray-700 text-xs bg-gray-50 px-2 py-1 rounded-lg truncate border border-gray-100">
              {bind.systemId}
            </p>
          </div>
          <div>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">TPS</p>
            <p className="font-bold text-gray-700 flex items-center gap-1.5 text-sm">
              <Zap className="w-3.5 h-3.5 text-amber-500" /> {bind.tps}/s
            </p>
          </div>
          <div>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1">Index</p>
            <p className="font-bold text-gray-500 text-sm">#{bind.index}</p>
          </div>
        </div>

        <WindowBar pending={bind.pendingSubmits} max={bind.maxWindowSize} />

        <div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-1.5">Allowed Types</p>
          <div className="flex flex-wrap gap-1.5">
            {bind.allowedMsgTypes && bind.allowedMsgTypes.length > 0 ? (
              bind.allowedMsgTypes.map(t => (
                <span key={t} className="px-2 py-0.5 bg-[#0C4550]/5 text-[#0C4550] rounded-md text-[10px] font-black uppercase tracking-wider border border-[#0C4550]/10">
                  {t}
                </span>
              ))
            ) : (
              <span className="text-xs text-gray-400 italic">All types</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Form Field Component ──────────────────────────────────────────────────────

const Field = ({ label, hint, children }) => (
  <div>
    <label className="block text-sm font-bold text-gray-700 mb-1.5">{label}</label>
    {children}
    {hint && <p className="text-xs text-gray-400 mt-1 ml-0.5">{hint}</p>}
  </div>
);

const inp = "w-full px-4 py-2.5 rounded-xl border-2 border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0C4550] focus:ring-2 focus:ring-[#0C4550]/10 transition-all text-sm";

// ─── Default form state ────────────────────────────────────────────────────────

const DEFAULT_FORM = {
  host: '', port: 2775, systemId: '', password: '',
  systemType: '', tmId: '', maxWindowSize: 250, tps: 100,
  allowedMsgTypes: [],
};

// ─── Main Component ────────────────────────────────────────────────────────────

export const Controlpanel = () => {
  const [binds, setBinds]             = useState([]);
  const [isLoading, setIsLoading]     = useState(true);
  const [sseConnected, setSseConnected] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingBind, setEditingBind] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [bindToDelete, setBindToDelete] = useState(null);
  const [notification, setNotification] = useState(null);
  const [formData, setFormData]       = useState(DEFAULT_FORM);
  const [isSaving, setIsSaving]       = useState(false);

  // ── Auth header ──────────────────────────────────────────────────────────────
  const authHeader = useCallback(() => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  }), []);

  // ── Notification ─────────────────────────────────────────────────────────────
  const notify = useCallback((type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification(null), 3500);
  }, []);

  // ── Unwrap ApiResponse envelope ───────────────────────────────────────────────
  // Handles: bare array, { data: [...] }, { result: [...] }, { payload: [...] }
  const unwrapBinds = (raw) => {
    if (Array.isArray(raw)) return raw;
    for (const key of ['data', 'result', 'payload', 'body', 'sessions']) {
      if (Array.isArray(raw[key])) return raw[key];
    }
    return [];
  };

  // ── Fetch binds via REST ───────────────────────────────────────────────────
  const fetchBinds = useCallback(async (silent = false) => {
    if (!silent) setIsLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/v1/smpp/binds`, { headers: authHeader() });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const raw = await res.json();
      setBinds(unwrapBinds(raw));
      setSseConnected(true);  // reuse indicator to mean "polling OK"
    } catch (err) {
      setSseConnected(false);
      if (!silent) notify('error', 'Could not load binds — ' + err.message);
    } finally {
      if (!silent) setIsLoading(false);
    }
  }, [authHeader, notify]);

  // ── Poll every 5 s (replaces SSE — avoids EventSource auth header limit) ────
  useEffect(() => {
    fetchBinds();                                // immediate load on mount
    const id = setInterval(() => fetchBinds(true), 5000);
    return () => clearInterval(id);
  }, [fetchBinds]);

  // ── Stats ────────────────────────────────────────────────────────────────────
  const stats = {
    total:     binds.length,
    connected: binds.filter(b => b.bound).length,
    atCapacity: binds.filter(b => b.atCapacity).length,
  };

  // ── CRUD handlers ─────────────────────────────────────────────────────────────

  const handleDelete = async () => {
    if (!bindToDelete) return;
    try {
      const res = await fetch(`${API_URL}/api/v1/smpp/binds/${bindToDelete.id}`, {
        method: 'DELETE', headers: authHeader(),
      });
      if (!res.ok) throw new Error('Delete failed');
      notify('success', `Bind "${bindToDelete.id}" removed`);
      setBindToDelete(null);
      setIsDeleteOpen(false);
      fetchBinds();
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    const isEdit = !!editingBind;
    const url    = isEdit
      ? `${API_URL}/api/v1/smpp/binds/${editingBind.id}`
      : `${API_URL}/api/v1/smpp/binds/add`;
    const method = isEdit ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method, headers: authHeader(), body: JSON.stringify(formData),
      });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || 'Operation failed');
      }
      notify('success', isEdit ? `Bind "${editingBind.id}" updated` : 'New bind added');
      closeModal();
      fetchBinds();
    } catch (err) {
      notify('error', err.message);
    } finally {
      setIsSaving(false);
    }
  };

  // ── Modal helpers ─────────────────────────────────────────────────────────────

  const openCreate = () => {
    setEditingBind(null);
    setFormData(DEFAULT_FORM);
    setIsModalOpen(true);
  };

  const openEdit = (bind) => {
    setEditingBind(bind);
    setFormData({
      host:            bind.host,
      port:            bind.port,
      systemId:        bind.systemId,
      password:        '',             // never echo password back
      systemType:      bind.systemType || '',
      tmId:            bind.tmId       || '',
      maxWindowSize:   bind.maxWindowSize,
      tps:             bind.tps,
      allowedMsgTypes: bind.allowedMsgTypes ? [...bind.allowedMsgTypes] : [],
    });
    setIsModalOpen(true);
  };

  const closeModal = () => { setIsModalOpen(false); setEditingBind(null); };

  const toggleMsgType = (type) => {
    setFormData(prev => ({
      ...prev,
      allowedMsgTypes: prev.allowedMsgTypes.includes(type)
        ? prev.allowedMsgTypes.filter(t => t !== type)
        : [...prev.allowedMsgTypes, type],
    }));
  };

  // ─────────────────────────────────────────────────────────────────────────────

  return (
    <div className="min-h-screen bg-[#F0EFEB] p-4 md:p-6 text-gray-800" style={{ fontFamily: "'DM Sans', 'Inter', sans-serif" }}>
      <div className="max-w-7xl mx-auto space-y-6">

        {/* ── HEADER ── */}
        <div className="bg-[#0C4550] rounded-2xl shadow-xl p-6 md:p-7 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 right-0 w-72 h-full bg-gradient-to-l from-[#C5F637]/10 to-transparent" />
            <div className="absolute -bottom-8 -right-8 w-48 h-48 rounded-full bg-[#C5F637]/5" />
          </div>

          <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-4">
            {/* Title */}
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 bg-white/10 rounded-xl flex items-center justify-center border border-white/10">
                <Server className="h-7 w-7 text-[#C5F637]" />
              </div>
              <div>
                <h1 className="text-2xl font-black text-white tracking-tight">SMPP Controller</h1>
                <p className="text-[#A7A08F] text-sm font-medium mt-0.5">Manage SMPP binds in real-time</p>
              </div>
            </div>

            {/* Controls */}
            <div className="flex items-center gap-3">
              {/* SSE Indicator */}
              <div className={`flex items-center gap-2 px-3 py-2 rounded-xl border text-xs font-bold ${
                sseConnected
                  ? 'bg-emerald-900/30 border-emerald-700/40 text-emerald-400'
                  : 'bg-white/5 border-white/10 text-gray-400'
              }`}>
                {sseConnected
                  ? <><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /><Wifi className="w-3.5 h-3.5" /> LIVE (5s)</>
                  : <><WifiOff className="w-3.5 h-3.5" /> OFFLINE</>
                }
              </div>

              <button
                onClick={fetchBinds}
                disabled={isLoading}
                className="p-2.5 bg-white/10 hover:bg-white/15 border border-white/10 rounded-xl text-[#C5F637]/80 hover:text-[#C5F637] transition-all"
                title="Refresh"
              >
                <RefreshCw className={`w-5 h-5 ${isLoading ? 'animate-spin' : ''}`} />
              </button>

              <button
                onClick={openCreate}
                className="flex items-center gap-2 bg-[#C5F637] hover:bg-[#bcec2a] text-[#0C4550] px-5 py-2.5 rounded-xl text-sm font-black transition-all shadow-md active:scale-95"
              >
                <Plus className="w-4 h-4" /> Add Bind
              </button>
            </div>
          </div>
        </div>

        {/* ── STATS ── */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <StatCard icon={<Network className="w-5 h-5 text-[#0C4550]" />}   label="Total Binds"    value={stats.total} />
          <StatCard icon={<Activity className="w-5 h-5 text-emerald-600" />} label="Connected"      value={stats.connected} accent="bg-emerald-50" />
          <StatCard icon={<Zap className="w-5 h-5 text-amber-500" />}       label="At Capacity"    value={stats.atCapacity} accent="bg-amber-50" />
        </div>

        {/* ── BIND GRID ── */}
        {isLoading && binds.length === 0 ? (
          <div className="flex items-center justify-center py-24">
            <Loader className="w-8 h-8 text-[#0C4550]/40 animate-spin" />
          </div>
        ) : binds.length === 0 ? (
          <div className="text-center py-24 bg-white rounded-2xl border-2 border-dashed border-gray-200">
            <Server className="w-10 h-10 text-[#0C4550]/20 mx-auto mb-3" />
            <h3 className="text-lg font-bold text-gray-700">No Binds Configured</h3>
            <p className="text-gray-400 text-sm mt-1">Click "Add Bind" to create your first SMPP session.</p>
            <button onClick={openCreate} className="mt-5 text-[#0C4550] font-bold text-sm hover:underline flex items-center gap-1.5 mx-auto">
              <Plus className="w-4 h-4" /> Add your first bind
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
            {binds.map(bind => (
              <BindCard
                key={bind.id}
                bind={bind}
                onEdit={() => openEdit(bind)}
                onDelete={() => { setBindToDelete(bind); setIsDeleteOpen(true); }}
              />
            ))}
          </div>
        )}
      </div>

      {/* ── ADD / EDIT MODAL ── */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0C4550]/50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col border border-gray-100">

            {/* Modal header */}
            <div className="flex justify-between items-center px-6 py-5 border-b border-gray-100">
              <h3 className="text-lg font-black text-[#0C4550]">
                {editingBind ? `Edit Bind — ${editingBind.id}` : 'Add New SMPP Bind'}
              </h3>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 p-1 hover:bg-gray-100 rounded-lg transition-all">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Modal body */}
            <form onSubmit={handleSubmit} className="p-6 overflow-y-auto flex-1 space-y-5">

              {/* Connection */}
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Field label="Host / IP" hint="SMPP server address">
                  <input type="text" required placeholder="smpp.example.com" className={inp}
                    value={formData.host} onChange={e => setFormData(p => ({...p, host: e.target.value}))} />
                </Field>
                <Field label="Port">
                  <input type="number" required className={inp}
                    value={formData.port} onChange={e => setFormData(p => ({...p, port: +e.target.value}))} />
                </Field>
                <Field label="System Type" hint="Leave blank if not required">
                  <input type="text" placeholder="CMT" className={inp}
                    value={formData.systemType} onChange={e => setFormData(p => ({...p, systemType: e.target.value}))} />
                </Field>
              </div>

              {/* Credentials */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Field label="System ID">
                  <input type="text" required className={`${inp} font-mono`}
                    value={formData.systemId} onChange={e => setFormData(p => ({...p, systemId: e.target.value}))} />
                </Field>
                <Field label="Password" hint={editingBind ? "Leave blank to keep existing" : undefined}>
                  <input type="password" required={!editingBind} className={`${inp} font-mono`}
                    value={formData.password} onChange={e => setFormData(p => ({...p, password: e.target.value}))} />
                </Field>
              </div>

              {/* Telemarketer ID */}
              <Field label="TM ID (Telemarketer ID)" hint="Used for DLT compliance hash">
                <input type="text" placeholder="1234567890" className={`${inp} font-mono`}
                  value={formData.tmId} onChange={e => setFormData(p => ({...p, tmId: e.target.value}))} />
              </Field>

              {/* Window & TPS */}
              <div className="grid grid-cols-2 gap-4">
                <Field label="Max Window Size" hint="Concurrent in-flight PDUs">
                  <input type="number" min="1" max="2000" required className={inp}
                    value={formData.maxWindowSize} onChange={e => setFormData(p => ({...p, maxWindowSize: +e.target.value}))} />
                </Field>
                <Field label="TPS" hint="Max transactions per second">
                  <input type="number" min="1" max="5000" required className={inp}
                    value={formData.tps} onChange={e => setFormData(p => ({...p, tps: +e.target.value}))} />
                </Field>
              </div>

              {/* Message Types */}
              <Field label="Allowed Message Types" hint="Leave all unchecked to allow everything">
                <div className="flex flex-wrap gap-3 mt-1">
                  {['SINGLE', 'BULK'].map(type => {
                    const checked = formData.allowedMsgTypes.includes(type);
                    return (
                      <button
                        key={type}
                        type="button"
                        onClick={() => toggleMsgType(type)}
                        className={`flex items-center gap-2 px-4 py-2.5 rounded-xl border-2 text-sm font-bold transition-all ${
                          checked
                            ? 'border-[#0C4550] bg-[#0C4550]/5 text-[#0C4550]'
                            : 'border-gray-200 text-gray-500 hover:border-[#0C4550]/30'
                        }`}
                      >
                        <span className={`w-4 h-4 rounded border flex items-center justify-center flex-shrink-0 ${
                          checked ? 'bg-[#0C4550] border-[#0C4550]' : 'border-gray-300'
                        }`}>
                          {checked && <CheckCircle className="w-3 h-3 text-white" />}
                        </span>
                        {type}
                      </button>
                    );
                  })}
                </div>
              </Field>

              {/* Actions */}
              <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                <button type="button" onClick={closeModal}
                  className="px-5 py-2.5 text-gray-600 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 font-bold text-sm transition-all">
                  Cancel
                </button>
                <button type="submit" disabled={isSaving}
                  className="px-7 py-2.5 text-white bg-[#0C4550] hover:bg-[#0A3A44] rounded-xl font-bold text-sm transition-all shadow-md active:scale-95 flex items-center gap-2 disabled:opacity-60">
                  {isSaving ? <Loader className="w-4 h-4 animate-spin" /> : editingBind ? <Edit3 className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  {isSaving ? 'Saving…' : editingBind ? 'Update & Rebind' : 'Add Bind'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── DELETE CONFIRM ── */}
      {isDeleteOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#0C4550]/60 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-7 text-center border border-gray-100">
            <div className="w-14 h-14 mx-auto bg-red-50 rounded-full flex items-center justify-center border-2 border-red-100 mb-5">
              <ShieldAlert className="w-7 h-7 text-red-500" />
            </div>
            <h3 className="text-xl font-black text-gray-800 mb-2">Remove Bind?</h3>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              This will immediately unbind <strong className="text-gray-800 font-bold">{bindToDelete?.id}</strong> from the SMPP session pool. In-flight messages may be lost.
            </p>
            <div className="flex gap-3">
              <button onClick={() => setIsDeleteOpen(false)}
                className="flex-1 py-2.5 text-gray-700 bg-white border-2 border-gray-200 rounded-xl hover:bg-gray-50 font-bold text-sm transition-all">
                Cancel
              </button>
              <button onClick={handleDelete}
                className="flex-1 py-2.5 text-white bg-red-500 hover:bg-red-600 rounded-xl font-bold text-sm shadow-sm hover:shadow transition-all">
                Remove Bind
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── TOAST ── */}
      {notification && (
        <div className={`fixed bottom-5 right-5 flex items-center gap-3 px-5 py-3.5 rounded-xl shadow-xl z-50 border text-sm font-bold ${
          notification.type === 'success'
            ? 'bg-[#C5F637] text-[#0C4550] border-[#bcec2a]'
            : 'bg-red-50 text-red-600 border-red-100'
        }`}>
          {notification.type === 'success'
            ? <CheckCircle className="w-4 h-4 flex-shrink-0" />
            : <AlertCircle className="w-4 h-4 flex-shrink-0" />}
          {notification.message}
        </div>
      )}
    </div>
  );
};

export default Controlpanel;